import first from "assets/images/how/first.png";
import second from "assets/images/how/second.png";
import third from "assets/images/how/third.png";

export const steps = [
  {
    img: first,
    desc: "Download and install browser extension Metamask.",
  },
  {
    img: second,
    desc: "If this is your first time using Metamask, buy some Ether using the button in the plugin.",
  },
  {
    img: third,
    desc: " Once the plugin is installed, our website will recognize it and allow you to buy, bid on and sell Doge’s.",
  },
];
